import React from 'react';
import '../css/whychoosepolicysamjho.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faLightbulb, faChartPie, faTools } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet-async';

const WhyChoosePolicySamjho = () => {
  return (
    <div className="why-choose-section">
      <Helmet>
        <title>Insurance Guidance | Why Choose Policy Samjho for Policy Consultation</title>
        <meta
          name="description"
          content="Get expert insurance guidance and clarity in insurance with Policy Samjho. We provide personalized insurance recommendations and policy reviews to help you decide smartly."
        />
        <meta
          name="keywords"
          content="insurance guidance, policy consultation, clarity in insurance, insurance expert advice, insurance policy review, understand insurance policy, insurance advice India"
        />
        <link rel="canonical" href="https://policysamjho.com/why-choose-policy-samjho" />
      </Helmet>
      
      <div className="left-content">
        <p className="sub-heading">
          <span className="icon-sparkle">✨</span> Why Choose Policy Samjho?
        </p>
        <h1 className="main-heading">
          Clarity in <span className="highlight-text">Insurance</span> <br />
          Shouldn't Feel Like <br />
          <span className="highlight-text">Rocket</span>
          <span className="highlight-text"> Science</span>
        </h1>
      </div>

      <div className="right-cards-grid">
        <div className="card-item border-blue">
          <div className="card-icon-container bg-blue">
            <FontAwesomeIcon icon={faBook} className="card-icon blue-icon" />
          </div>
          <h3 className="card-title">Understand Insurance Policy</h3>
          <p className="card-description">
            We turn complex policy terms into everyday
            language you actually get. No jargon, just
            clarity in insurance.
          </p>
        </div>

        <div className="card-item border-yellow">
          <div className="card-icon-container bg-yellow">
            <FontAwesomeIcon icon={faLightbulb} className="card-icon yellow-icon" />
          </div>
          <h3 className="card-title">Expert Insurance Advice</h3>
          <p className="card-description">
            Speak to our Insurance
            Strategists—not salespeople. Real
            policy consultation. No pressure.
          </p>
        </div>

        <div className="card-item border-pink">
          <div className="card-icon-container bg-pink">
            <FontAwesomeIcon icon={faChartPie} className="card-icon pink-icon" />
          </div>
          <h3 className="card-title">Personalized Recommendations</h3>
          <p className="card-description">
            We suggest only what
            truly fits your life goals,
            budget, and future
            needs.
          </p>
        </div>

        <div className="card-item border-orange">
          <div className="card-icon-container bg-orange">
            <FontAwesomeIcon icon={faTools} className="card-icon orange-icon" />
          </div>
          <h3 className="card-title">Smart Insurance Tools</h3>
          <p className="card-description">
            From SIP to Retirement
            —we’ve built calculators
            that help you plan,
            compare, and decide
            smartly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhyChoosePolicySamjho;